import type { ICard } from "../../cardsSlice";

export const major7Card: ICard = {
    id: "major_7",
    arcana: "major",
    number: 7,
    suit: "major",
    court: "major",
    name: "Колесница",
    nameEn: "The Chariot",
    keywords: ["Победа", "Движение", "Контроль"],
    symbolism: [
      "Воин в колеснице, запряжённой сфинксами",
      "Звёздный балдахин, корона, символы на доспехах"
    ],
    symbolismInterpretation:
      "Символ целеустремлённости, управления разными силами для достижения цели",
    archetype: "Герой, преодолевающий преграды через волю",
    psychology: "Контроль над внутренними импульсами, сила воли",
    upright: {
      personality: "Решимость, сила воли, сфокусированность",
      relationships: "Движение вперёд, преодоление барьеров",
      work: "Успех, триумф, продвижение",
      spirituality: "Сосредоточенность, достижение цели",
      examples: ["Активное продвижение", "Контроль над ситуацией", "Твёрдая воля"]
    },
    reversed: {
      meaning: "Хаос, потеря контроля, внутренняя борьба",
      nuances: "Расфокусировка, конфликт целей и средств"
    },
    associations: ["Воля", "Движение", "Преодоление", "Путь"],
    combinations: ["С Силой — уверенное преодоление", "С Повешенным — необходимость остановки"],
    readingTips: ["Отличать решимость от упрямства", "Понимать, что вас движет"],
    selfQuestions: ["Чего я пытаюсь достичь?", "Где я теряю контроль?"]
  };


